// @ts-nocheck

(() => {
  const STORAGE_KEY = "mte_wishlist";

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

    document.dispatchEvent(
      new CustomEvent("mte:wishlist-updated", {
        detail: {
          wishlist: items,
          count: items.length,
        },
      })
    );
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderWishlist() {
    const grid = document.querySelector("[data-mte-wishlist-grid]");
    const empty = document.querySelector("[data-mte-wishlist-empty]");
    const count = document.querySelector("[data-mte-wishlist-page-count]");

    if (!grid || !empty || !count) return;

    const items = getWishlist();

    count.textContent = `${items.length} ${
      items.length === 1 ? "producto" : "productos"
    }`;
    count.hidden = false;

    if (items.length === 0) {
      grid.innerHTML = "";
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;

    grid.innerHTML = items
      .map((item) => {
        const availableText = item.available
          ? "Disponible para compra"
          : "Agotado";

        const action = item.available && item.variantId
          ? `
            <form method="post" action="/cart/add" class="mte-wishlist-page__cart-form">
              <input type="hidden" name="id" value="${escapeHtml(item.variantId)}">
              <input type="hidden" name="quantity" value="1">

              <button class="mte-wishlist-page__cart-button" type="submit">
                Agregar al carrito
              </button>
            </form>
          `
          : `
            <a class="mte-wishlist-page__view-button" href="${escapeHtml(item.url)}">
              Ver producto
            </a>
          `;

        return `
          <li class="mte-wishlist-page__item">
            <article class="mte-wishlist-page__card">
              <div class="mte-wishlist-page__media">
                <button
                  class="mte-wishlist-page__remove"
                  type="button"
                  data-mte-wishlist-remove="${escapeHtml(item.handle)}"
                  aria-label="Quitar ${escapeHtml(item.title)} de favoritos"
                  title="Quitar de favoritos"
                >
                  ×
                </button>

                <a href="${escapeHtml(item.url)}">
                  ${
                    item.image
                      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
                      : ""
                  }
                </a>
              </div>

              <div class="mte-wishlist-page__content">
                ${
                  item.vendor
                    ? `<span class="mte-wishlist-page__vendor">${escapeHtml(item.vendor)}</span>`
                    : ""
                }

                <h2 class="mte-wishlist-page__product-title">
                  <a href="${escapeHtml(item.url)}">
                    ${escapeHtml(item.title)}
                  </a>
                </h2>

                <div class="mte-wishlist-page__price">
                  ${escapeHtml(item.price)}
                </div>

                <span class="mte-wishlist-page__availability ${
                  item.available ? "" : "is-unavailable"
                }">
                  ${availableText}
                </span>

                <div class="mte-wishlist-page__actions">
                  ${action}
                </div>
              </div>
            </article>
          </li>
        `;
      })
      .join("");
  }

  document.addEventListener("click", (event) => {
    const removeButton = event.target.closest("[data-mte-wishlist-remove]");

    if (!removeButton) return;

    const handle = removeButton.dataset.mteWishlistRemove;
    const updated = getWishlist().filter((item) => item.handle !== handle);

    saveWishlist(updated);
    renderWishlist();

    if (window.MTEWishlist?.refresh) {
      window.MTEWishlist.refresh();
    }
  });

  document.addEventListener("DOMContentLoaded", renderWishlist);
  document.addEventListener("mte:wishlist-updated", renderWishlist);
  document.addEventListener("shopify:section:load", renderWishlist);
})();